<template>
  <div class="menu-search">
    <app-form-autocomplete
      v-model="item"
      :search-input.sync="searchInput"
      :items="items"
      item-value="id"
      item-text="label"
      box-shadow
      round
    />

    <span class="menu-search__icon" @click="onClickButton">
      <app-icon name="magnifier" size="md" color="white"/>
    </span>
  </div>
</template>

<script>
import Autocomplete from '../Form/Autocomplete.vue'
import Button from '../Button/Button.vue'
import Icon from '../Icon/Icon.vue'

export default {
  name: 'AppMenuSearch',
  status: 'prototype',
  release: '1.0.0',
  components: { Autocomplete, Button, Icon },
  props: {},
  data () {
    return {
      item: {},
      items: [
        {
          id: '1',
          label: 'Item da busca com a palavra buscada destacada'
        },
        {
          id: '2',
          label: 'Palavra destacada no item da busca'
        },
        {
          id: '3',
          label: 'Trazer nomes de pesquisas com a palavra buscada'
        },
        {
          id: '4',
          label: 'Palavra destacada no item da busca'
        },
        {
          id: '5',
          label: 'Trazer nomes de pesquisas com a palavra buscada'
        },
        {
          id: '6',
          label: 'Item da busca com a palavra buscada destacada'
        }
      ],
      searchInput: ''
    }
  },
  computed: {
    isOpen: {
      get () {
        return !!this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', val)
      }
    }
  },
  watch: {
    searchInput (val) {
      // get items from external API
      // this.item = data;
    }
  },
  methods: {
    onClickButton () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.menu-search {
  position: relative;
  width: 100%;
  &__icon {
    position: absolute;
    display: flex;
    width: 64px;
    height: 64px;
    right: -10px;
    top: -10px;
    border-radius: 50%;
    background: $color-pink-light;
    align-items: center;
    justify-content: center;
    z-index: 99;
    cursor: pointer;
  }
}
</style>
